import * as _lodash2 from "lodash.get";

var _lodash = "default" in _lodash2 ? _lodash2.default : _lodash2;

import _AuthTypes from "./AuthTypes";
var exports = {};

var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = void 0;

const lodash_get_1 = __importDefault(_lodash);

const AuthTypes_1 = _AuthTypes;

class Auth {
  static chooseAuth(opts = {}, config = {}) {
    let type;

    if (opts.authType) {
      if (opts.authType !== "none" && (0, lodash_get_1.default)(config, opts.authType)) {
        type = opts.authType;
      }
    } else {
      for (const key in AuthTypes_1.AuthTypes) {
        if ((0, lodash_get_1.default)(config, key)) {
          type = key;
        }
      }
    }

    return type;
  }

}

exports.Auth = Auth; //# sourceMappingURL=Auth.js.map

export default exports;